import { render, staticRenderFns } from "./ImageEffectsPropertiesCreate.vue?vue&type=template&id=25d1cf16"
import script from "./ImageEffectsPropertiesCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageEffectsPropertiesCreate.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports